import axios from 'axios'
const qs = require('qs')

const state = {
  clients: [],
  clientsSingle: {},
  clientsAddress: [],
}

const getters = {
  getClients (state) {
    return state.clients
  },
  getClientsSingle (state) {
    return state.clientsSingle
  },

  getClientsAddress (state) {
    return state.clientsAddress
  },
}

const mutations = {
  setClients (state, payload) {
    state.clients = payload
  },
  setClientsSingle (state, payload) {
    state.clientsSingle = payload
  },
  setClientsAddress (state, payload) {
    state.clientsAddress = payload
  },
  clearClientsSingle (state) {
    state.clientsSingle = null
  },
}

const actions = {
  fetchClientsList ({ commit, rootGetters }, meta) {
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios
      .get(
        `${rootGetters['api/clientsList']}${params}`,
      )
      .then((res) => {
        commit('setClients', res.data.items)

        return res
      })
      // .catch((err) => err)
  },
  fetchSingleClients ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/clientsSingle'](id))
      .then((res) => {
        commit('setClientsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createClients ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/clientsCreate'], data)
      .then((res) => {
        return res
      })
      // .catch((err) => err)
  },
  editClients ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/clientsEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteClients ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/clientsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getBranches.filter((val) => val.id !== id)
          commit('setClients', items)
        }

        return res
      })
      .catch((err) => err)
  },
  toBlackListClients ({ commit, getters, rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/clientsToBlackList'](id), data)
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getClients.map((v) => {
            if (v.id === id) {
              v.hasActiveBlock = {
                reason: data.reason,
                endBlocking: data.endBlocking,
              }
            }

            return v
          })
          commit('setClients', items)
          return res
        }
      })
      .catch((err) => err)
  },
  fetchClientsAddressList ({ commit, rootGetters }, data) {
    return axios
      .get(
        `${rootGetters['api/clientsAddressList']}?clientId=${data.clientId}&limit=${data.limit}`,
      )
      .then((res) => {
        commit('setClientsAddress', res.data.items)

        return res
      })
  },
  addAddressClients ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/clientsAddAddress'](id), data)
      .then((res) => {
        return res
      })
  },
  editAddressClients ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/clientsEditAddress'](id), data)
  },
  addPromocode ({ rootGetters }, { data, id }) {
    return axios.put(rootGetters['api/clientsAddPromoCode'](id), data)
      .then(res => {
      return res
    })
      .catch(err => err)
  },
  fetchClientInfo ({ rootGetters }, id) {
    return axios
      .get(rootGetters['api/clientInfo'](id)).then(res => {
        return res
      }).catch(err => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
